//css
import { Container, Text, Icon } from "@jds/core";
import classes from "./JioSnapStats.module.css";
import Map from "../components/Map/Map";
import { useState } from "react";
import {
  TransformWrapper,
  TransformComponent,
  useControls,
} from "react-zoom-pan-pinch";

const Controls = () => {
  const { zoomIn, zoomOut, resetTransform } = useControls();

  return (
    <div className={`${classes["map-tool"]}`}>
      <Container gap={8} style={{ paddingRight: "6px" }}>
        <Icon ic={"IcMinus"} onClick={() => zoomOut()} />
        <Icon ic={"IcAdd"} onClick={() => zoomIn()} />
      </Container>
      <Container
        gap={8}
        style={{ borderLeft: "1px solid #B5B5B5", paddingLeft: "6px" }}
      >
        <Icon ic={"IcFullscreenModeOff"} onClick={() => resetTransform()} />
        <Text
          text={`Recenter`}
          color="primary_grey_80"
          appearance="body-s-bold"
        />
      </Container>
    </div>
  );
};

const JioSnapStats = () => {
  const [selectedState, setSelectedState] = useState(null);
  const [hoverState, setHoverState] = useState(null);

  const stateSelect = (id, dataValue, dataStateValue) => {
    setSelectedState(dataStateValue);
  };
  const stateHover = (id, dataValue, dataStateValue) => {
    setHoverState(dataStateValue);
  };

  const sidePanelData = [
    {
      icon: "IcGroup",
      title: "Users",
      value: [
        { label: "Users Logged in", value: "16,74,927" },
        { label: "Users Logged out", value: "6,38,982" },
        { label: "Users with profile image", value: "13,35,981" },
        { label: "Guests Invited", value: "24,83,037" },
      ],
    },
    {
      icon: "IcCelebration",
      title: "Events",
      value: [
        { label: "Events created", value: "3,767" },
        { label: "Events edited", value: "23" },
        { label: "Events rescheduled", value: "32" },
        { label: "Events cancelled", value: "12" },
      ],
    },
    {
      icon: "IcPhoto",
      title: "Photos",
      value: [
        { label: "Albums created", value: "16,74,927" },
        { label: "Faces Detected", value: "6,38,982" },
      ],
    },
  ];
  const top10States = [
    {
      state: "Tamil Nadu",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Kerala",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Karnataka",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Andhra Pradesh",
      users: "2,92,497",
      photos: "8,26,376",
    },

    {
      state: "Bihar",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Maharashtra",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Rajasthan",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Gujarat",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Uttarakhand",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Odisha",
      users: "2,92,497",
      photos: "8,26,376",
    },
  ];
  const top10Districts = [
    {
      state: "Chennai",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Madurai",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Coimbatore",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Tiruchirappalli",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Salem",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Kanniyakumari",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Thoothukudi",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Vellore",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Thirunelveli",
      users: "2,92,497",
      photos: "8,26,376",
    },
    {
      state: "Dindigul",
      users: "2,92,497",
      photos: "8,26,376",
    },
  ];
  return (
    <div className={`${classes["grid-main"]}`}>
      <div className={`${classes["sidepanel"]}`}>
        <div className={`${classes["sidepanel-item"]}`}>
          <Container fullWidth direction="column" gap={16}>
            <Container fullWidth direction="column" gap={4}>
              <Text
                text="Total Users "
                color="primary_grey_80"
                appearance="body-s-bold"
              />
              <Text text={"53,74,927"} appearance="heading_xs" />
            </Container>
            <Container fullWidth direction="column" gap={4}>
              <Text
                text="Total Photos Uploaded "
                color="primary_grey_80"
                appearance="body-s-bold"
              />
              <Text text={"18,26,91,298"} appearance="heading_xs" />
            </Container>
            <Container fullWidth direction="column">
              {sidePanelData.map((item, index) => (
                <Container
                  fullWidth
                  direction="column"
                  gap={16}
                  style={{
                    borderTop: "1px solid #e0e0e0",
                    paddingTop: "20px",
                  }}
                >
                  <Container>
                    <Container gap={12} verticalAlign="center">
                      <Icon
                        ic={`${item.icon}`}
                        kind="background"
                        size="large"
                      />
                      <Text text={`${item.title}`} appearance="body-m-bold" />
                    </Container>
                  </Container>
                  <Container fullWidth direction="column">
                    {item?.value?.map((data, index) => (
                      <Container
                        fullWidth
                        horizontalAlign={"space-between"}
                        verticalAlign="center"
                      >
                        <Text
                          text={`${data?.label}`}
                          color="primary_grey_80"
                          appearance="body-s-bold"
                        />
                        <Text
                          text={`${data?.value}`}
                          appearance="body-s-bold"
                        />
                      </Container>
                    ))}
                  </Container>
                </Container>
              ))}
            </Container>
          </Container>
        </div>
        <div
          className={`${classes["sidepanel-item"]}`}
          style={{ marginTop: "12px" }}
        >
          <Container fullWidth direction="column">
            <Container
              gap={12}
              verticalAlign="center"
              style={{ marginBottom: "12px" }}
            >
              <Icon ic={`IcLocation`} kind="background" size="large" />
              <Text
                text={`Top 10 ${selectedState ? "districts" : "states"}`}
                appearance="body-m-bold"
              />
            </Container>

            {selectedState
              ? top10Districts.map((item, index) => (
                  <Container
                    gap={12}
                    fullWidth
                    style={{
                      borderBottom: "1px solid #e0e0e0",
                      paddingBottom: "12px",
                      marginBottom: "12px",
                    }}
                  >
                    <Text text={index + 1} appearance="body-m-bold" />
                    <Container fullWidth direction="column" gap={1}>
                      <Text text={`${item.state}`} appearance="body-m-bold" />
                      <Container
                        fullWidth
                        horizontalAlign={"space-between"}
                        verticalAlign="center"
                      >
                        <Text
                          text={`Users`}
                          color="primary_grey_80"
                          appearance="body-s-bold"
                        />
                        <Text text={`${item.users}`} appearance="body-s-bold" />
                      </Container>
                      <Container
                        fullWidth
                        horizontalAlign={"space-between"}
                        verticalAlign="center"
                      >
                        <Text
                          text={`Photos Uploaded `}
                          color="primary_grey_80"
                          appearance="body-s-bold"
                        />
                        <Text
                          text={`${item.photos}`}
                          appearance="body-s-bold"
                        />
                      </Container>
                    </Container>
                  </Container>
                ))
              : top10States.map((item, index) => (
                  <Container
                    gap={12}
                    fullWidth
                    style={{
                      borderBottom: "1px solid #e0e0e0",
                      paddingBottom: "12px",
                      marginBottom: "12px",
                    }}
                  >
                    <Text text={index + 1} appearance="body-m-bold" />
                    <Container fullWidth direction="column" gap={1}>
                      <Text text={`${item.state}`} appearance="body-m-bold" />
                      <Container
                        fullWidth
                        horizontalAlign={"space-between"}
                        verticalAlign="center"
                      >
                        <Text
                          text={`Users`}
                          color="primary_grey_80"
                          appearance="body-s-bold"
                        />
                        <Text text={`${item.users}`} appearance="body-s-bold" />
                      </Container>
                      <Container
                        fullWidth
                        horizontalAlign={"space-between"}
                        verticalAlign="center"
                      >
                        <Text
                          text={`Photos Uploaded `}
                          color="primary_grey_80"
                          appearance="body-s-bold"
                        />
                        <Text
                          text={`${item.photos}`}
                          appearance="body-s-bold"
                        />
                      </Container>
                    </Container>
                  </Container>
                ))}
          </Container>
        </div>
      </div>
      <div className={`${classes["mappanel"]}`}>
        <div
          className={`${classes["detail-modal"]}`}
          style={{ display: hoverState ? "block" : "none" }}
        >
          <Container fullWidth direction="column" gap={16}>
            <Container fullWidth direction="column" gap={1}>
              <Text text={hoverState} appearance="body-m-bold" />
              <Text
                text={"Rank 1"}
                color="primary_grey_80"
                appearance="body-s-bold"
              />
            </Container>
            <Container fullWidth direction="column" gap={1}>
              <Text
                text={"Users"}
                color="primary_grey_80"
                appearance="body-s-bold"
              />
              <Text text={"2,92,497"} appearance="body-l-bold" />
            </Container>
            <Container fullWidth direction="column" gap={1}>
              <Text
                text={"Photos Uploaded"}
                color="primary_grey_80"
                appearance="body-s-bold"
              />
              <Text text={"8,26,376"} appearance="body-l-bold" />
            </Container>
          </Container>
        </div>
        <Container fullWidth gap={5} verticalAlign="center">
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedState(null);
            }}
          >
            <Text
              text={"India"}
              appearance="heading_xs"
              color={selectedState ? "primary-50" : ""}
            />
          </div>
          {selectedState && (
            <>
              <Icon ic={"IcChevronRight"} />
              <Text text={selectedState} appearance="heading_xs" />
            </>
          )}
        </Container>

        <TransformWrapper>
          <Controls />

          <TransformComponent>
            <Map
              stateSelect={stateSelect}
              stateHover={stateHover}
              selectedState={selectedState}
            />
          </TransformComponent>
        </TransformWrapper>
      </div>
    </div>
  );
};

export default JioSnapStats;
